
export function checkFunktionFuerBereich(function_key: string, bereich_key: string) {
    switch (function_key) {
        case 'InformationenHilfe_Kontakte':
            return bereich_key !== 'sonstige';
        case 'InformationenHilfe_Medien':
            return bereich_key === 'kultur';
        case 'KontakteAnsprechpartner_Karte':
            return bereich_key !== 'kultur';
        case 'Zusatztools_Tab_Import_Excel':
            return false/*bereich_key !== 'kultur'*/;
        case 'Zusatztools_Tab_Zertifizierung':
            return bereich_key !== 'kultur';
    }
    return true;
}


